"use strict";

var video = document.querySelector('.js-video');
var picture = document.querySelector('.js-picture');
if (video) {
  video.onloadeddata = function () {
    $(picture).addClass('is-hide');
  };
  video.src = video.getAttribute('data-src');
}
$(document).on('click', '.menu-open', function () {
  var parent = $(this).parents('li');
  if ($(this).hasClass('open')) {
    $(parent).find('ul').stop(true, true).slideUp(500);
    clearTimeout($.data(this, 'timer'));
    $(this).removeClass('open');
  } else {
    $(parent).find('ul').stop(true, true).slideDown(500);
    clearTimeout($.data(this, 'timer'));
    $(this).addClass('open');
  }
});
$(document).on('click', '.menu-toggle', function () {
  if ($(this).hasClass('open')) {
    $('.header__container').removeClass('open');
    $(this).removeClass('open');
  } else {
    $('.header__container').addClass('open');
    $(this).addClass('open');
  }
});